// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Data, Diagram, User, VideoAdd, MenuBoard, Timer1, VoiceSquare, Timer, House, Book, Fatrows, PresentionChart } from 'iconsax-react';

// type
import { NavItemType } from '@/types/bs-types/menu';
import DashboardSvgIcon from '@/assets/svgs/DashboardSvgIcon';
import PurchaseSvgIcon from '@/assets/svgs/PurchaseSvgIcon';
import ReportFileSvgIcon from '@/assets/svgs/ReportFileSvgIcon';

// icons
const icons = {
  dashboard: DashboardSvgIcon,
  user: User,
  Purchase: PurchaseSvgIcon,
  department: Data,
  companies: House,
  timeIn: Timer1,
  publicHoliday: MenuBoard,
  leavePolicy: Book,
  adjustTime: Timer,
  role: Fatrows,
  leave: VideoAdd,
  chart: PresentionChart,
  inform: VoiceSquare,
  reportDaily: ReportFileSvgIcon
};

// ==============================|| MENU ITEMS - RESEARCH ||============================== //
// รายการ url path ทั้งหมดจะเป็น allowUsers List สำหรับการอนุญาติในการเข้าถึง url path จากหน้านี้
const rootPath = '/user';

const researchChildrenMenu = [
  {
    id: 'research-buget',
    title: 'งบประมาณวิจัย',
    type: 'item',
    url: `${rootPath}/research/budget/list`,
    icon: icons.dashboard,
    children: [
      {
        id: 'research-budget-list',
        // title: <FormattedMessage id="menu.dashboard" />,
        title: 'งบประมาณวิจัย',
        type: 'item',
        url: `${rootPath}/research/budget/list`,
        icon: icons.dashboard
        // breadcrumbs: true
      },
      {
        id: 'research-budget-create',
        // title: <FormattedMessage id="menu.dashboard" />,
        title: 'เพิ่มโครงการ',
        type: 'item',
        url: `${rootPath}/research/budget/create`,
        icon: icons.dashboard
      },
      {
        id: 'research-budget-edit',
        // title: <FormattedMessage id="menu.dashboard" />,
        title: 'แก้ไขโครงการ',
        type: 'item',
        url: `${rootPath}/research/budget/edit`,
        icon: icons.dashboard
      }
    ]
  }
];

const researchs: NavItemType = {
  id: 'group-research',
  // title: <FormattedMessage id="menu.group-research" />,
  title: 'เจ้าหน้าที่การคลัง - งบวิจัย',
  icon: icons.dashboard,
  type: 'group',
  children: [...researchChildrenMenu]
};

const researchsManager: NavItemType = {
  id: 'group-manger-research',
  // title: <FormattedMessage id="menu.group-research" />,
  title: 'เจ้าหน้าที่การคลัง - งบวิจัย',
  icon: icons.dashboard,
  type: 'group',
  children: [
    {
      id: 'dashboard-research',
      title: 'แดชบอร์ด',
      type: 'item',
      url: `${rootPath}/research/dashboard`,
      icon: icons.dashboard
    },
    ...researchChildrenMenu
  ]
};

// ==============================|| MENU ITEMS - PAYMENTS ||============================== //
// รายการ url path ทั้งหมดจะเป็น allowUsers List สำหรับการอนุญาติในการเข้าถึง url path จากหน้านี้

const paymentReseachs: NavItemType = {
  id: 'group-payment',
  // title: <FormattedMessage id="menu.group-payment-research" />,
  title: 'เจ้าหน้าที่การเงิน - งบวิจัย',
  icon: icons.dashboard,
  type: 'group',
  children: [
    {
      id: 'payment-research-account',
      // title: <FormattedMessage id="menu.dashboard" />,
      title: 'รายการบัญชีผู้รับ',
      type: 'item',
      url: `${rootPath}/payment/research/account`,
      icon: icons.dashboard,
      children: []
    },
    {
      id: 'research-report',
      // title: <FormattedMessage id="menu.dashboard" />,
      title: 'รายการรอตรวจสอบ',
      type: 'item',
      url: `${rootPath}/payment/research/pending`,
      icon: icons.dashboard
    },
    {
      id: 'research-disbursement',
      // title: <FormattedMessage id="menu.dashboard" />,
      title: 'ประวัติรายการบัญชีผู้รับ',
      type: 'item',
      url: `${rootPath}/payment/research/history`,
      icon: icons.dashboard
    }
  ]
};
const UserReseachs: NavItemType = {
  id: 'group-payment',
  // title: <FormattedMessage id="menu.group-payment-research" />,
  title: 'เมนู',
  icon: icons.dashboard,
  type: 'group',
  children: [
    {
      id: 'admin-dashboard',
      title: 'แดชบอร์ด',
      type: 'item',
      url: `${rootPath}/latex-purchase/dashboard`,
      icon: icons.dashboard
    },
    {
      id: 'research-disbursement',
      // title: <FormattedMessage id="menu.dashboard" />,
      title: 'ประวัติขาย',
      type: 'item',
      url: `${rootPath}/latex-purchase/my-order/list`,
      icon: icons.Purchase
    },
    {
      id: 'admin-reports',
      title: 'รายงาน',
      icon: icons.reportDaily,
      type: 'collapse',
      children: [
        {
          id: 'admin-report-customer-summary',
          title: 'รายงานของฉัน',
          type: 'item',
          url: `${rootPath}/latex-purchase/my-order/my-summary`,
          icon: icons.reportDaily,
          breadcrumbs: true
        }
      ]
    }
  ]
};
export { paymentReseachs, researchs, researchsManager, UserReseachs };
